export const languages = { 
    'fr':   {text_hook: 'La data visualisation au service de la tuyauterie industrielle', 
             review: 'Publiez un Avis',
             publish: 'Publiez',
             tryOnline: 'Essayer en ligne, ',
             optimal_desk: '(optimal pour ordinateur)',
             follow_youtube: 'ou suivre sur ',
             simple_elbow: 'Coude Simple',
             double_elbow: 'Double Coude',
             double_elbow_oriented: 'Double Coude Orienté',
             slices_elbow: 'Coude en tranches',
             why_talk_data_viz: 'Pourquoi parler de data-visualisation ?',
             text_data_viz: 'La data-visualisation c\'est le pouvoir de visualiser des données en un instant pour optimiser le temps et réduire les coûts. Transformez les flux de données complexes en informations exploitables.',
             signup: 'S\'inscrire',
             register_beta: 'S\'inscrire à la newsletter et au programme Bêta',
             pipefitter: 'Tuyauteur',
             boilermaker: 'Chaudronnier',
             text_informations: 'Bientôt notre newsletter pour suivre notre actualité et être informé des mises à jour. Vous aurez également l\'opportunité d\'essayer les nouvelles fonctionnalités en participant en avant-première à nos programmes bêta, ouverts en partie aux suggestions et commentaires.',
             label_comment: 'Poster un commentaire',
             send: 'Envoyer',
             participate: 'Participez',
             text_participate: 'N\'hésitez pas à nous laisser un avis ! Votre retour est précieux pour nous aider à améliorer notre service.',
             no_comment: 'Il n\'y a pas de commentaires pour le moment.',
             no_opinion: 'Il n\'y a pas d\'avis pour le moment.',
             pipingdata_by: 'PipingData par ',
             other_app: 'Autres Applications',
             copyright: ' 2023 Tous droits réservés. ELM-web - PipingData',
             load: 'Chargement',
             confidenciality: 'Confidentialité',
             text_confidenciality: 'Cher utilisateur, Nous tenons à vous informer que notre site Web respecte pleinement le Règlement Général sur la Protection des Données (RGPD) de l\'Union européenne. En ce qui concerne les avis que vous fournissez, veuillez noter que nous les collectons uniquement dans le but de les afficher aux visiteurs de notre site. Vos avis contribuent à améliorer notre service et à informer d\'autres utilisateurs sur leur expérience potentielle avec nos produits ou services. En ce qui concerne les adresses e-mail, nous les collectons uniquement lorsque vous vous inscrivez volontairement à notre newsletter ou à notre programme bêta en fournissant votre consentement explicite. Ces adresses e-mail ne seront utilisées que dans le cadre spécifié et ne seront en aucun cas partagées, vendues ou louées à des tiers. Nous prenons la sécurité et la confidentialité de vos données personnelles très au sérieux. Si vous avez des questions ou des préoccupations concernant la façon dont nous utilisons vos données, n\'hésitez pas à nous contacter à l\'adresse: ',
             thank: 'Merci pour votre confiance et votre soutien.',
             trial_version: 'Version d\'essai',
             text_trial_version: 'Voir sur youTube pour cette fonctionnalité',
             back: 'Revenir',
             features: 'Fonctionalités :',
             diameters_sms: 'diamètres SMS',
             languages_number: '18 languages',
             units_measure: 'mm et pouces',
             settings_number: 'reglages des chiffres',
             polices_size: 'tailles des polices',
             formats_elbow: '(2D, 3D, 5D)',
             normes_diameter: '(ISO / ANSI)',
             progress: '(En cours...)',
             annoucement_comment: 'Bientôt ici un espace pour commentaires, avis et suggestions'
            }, 

    'en':   {text_hook: 'Data visualization for industrial piping', 
             review: 'Publish one Review',
             publish: 'Publish',
             tryOnline: 'Try online, ',
             optimal_desk: '(best for desktop)',
             follow_youtube: 'or follow on ',
             simple_elbow: 'Simple Elbow',
             double_elbow: 'Double Elbow',
             double_elbow_oriented: 'Double Elbow Oriented',
             slices_elbow: 'Sliced Elbow',
             why_talk_data_viz: 'Why talk about data visualization ?',
             text_data_viz: 'Data visualization is the power to instantly visualize data to optimize time and reduce costs. Transform complex data streams into actionable insights.',
             signup: 'Sign up',
             register_beta: 'Subscribe to the newsletter and beta program',
             pipefitter: 'Pipefitter',
             boilermaker: 'Boilermaker',
             text_informations: 'Soon our newsletter to stay updated on our latest news and receive updates. You\'ll also have the opportunity to try out new features by participating in our beta programs, which are partially open to suggestions and feedback.',
             label_comment: 'Post a comment',
             send: 'Send',
             participate: 'Participate',
             text_participate: 'Feel free to leave us a review! Your feedback is valuable to help us improve our service.',
             no_comment: 'There are no comments at the moment.',
             no_opinion: 'There are no reviews at the moment.',
             pipingdata_by: 'PipingData by ',
             other_app: 'Other Applications',
             copyright: ' 2023 All rights reserved. ELM-web - PipingData',
             load: 'Loading',
             confidenciality: 'confidenciality',
             text_confidenciality: 'Dear User, We would like to inform you that our website fully complies with the European Union\'s General Data Protection Regulation (GDPR). Regarding the reviews you provide, please note that we collect them solely for the purpose of displaying them to visitors of our site. Your reviews help us improve our service and inform other users about their potential experience with our products or services. Regarding email addresses, we only collect them when you voluntarily sign up for our newsletter or beta program by providing your explicit consent. These email addresses will only be used for the specified purpose and will never be shared, sold, or rented to third parties. We take the security and privacy of your personal data very seriously. If you have any questions or concerns about how we use your data, please feel free to contact us at: ',
             thank: 'Thank you for your trust and support.',
             trial_version: 'Trial version',
             text_trial_version: 'Watch on YouTube for this feature',
             back: 'Back',
             features: 'Features :',
             diameters_sms: 'SMS diameters',
             languages_number: '(18 languages)',
             units_measure: 'Mm and inches',
             settings_number: 'Settings the numbers',
             polices_size: 'Font size',
             formats_elbow: '(2D, 3D, 5D)',
             normes_diameter: '(ISO / ANSI)',
             progress: '(In progress...)',
             annoucement_comment: 'Soon here a space for comments, opinions and suggestions'
            }
}